import React, { useEffect, useState } from "react";
//import axios from '../../../node_modules-back/axios';
import axios from 'axios'
//import { useForm } from '../../../node_modules-back/react-hook-form/dist';
import { useForm } from 'react-hook-form';
import { getUrl } from "../../ApiCall/GetUrl";


import Footer from "../Footer/Footer";
// Importación de los estilos
import "../../styles/Admin.css"

export default function ClientTable(){
  
  const [clientes, setClientes] = useState([]);
  useEffect(() => {
    axios.get(getUrl() + "/get_all_client").then(response => {
      setClientes(response.data);
      console.log("Este es el response.data de clientes: ", response.data)
    }).catch(error => {
      console.log("Error fetching data de clientes: ", error); 
      setClientes(["Hubo un error al obtener la información"])
    });
  }, [])
  var cont = 0;

  return <>
      <div className="container mt-5 mb-5">
        <div className="tabla">
          <table>
            <thead>
              <tr>
                <th>No.</th>
                <th>Correo</th>
                <th>Persona</th>
                <th>Nombre</th>
                <th>Número</th>
                <th>Género</th>
                <th>Ocupación</th>
              </tr>
            </thead>
            <tbody>
            {clientes.map(row => <tr>
                <td className="pos">{++cont}</td>
                <td>{row.client_email}</td>
                <td>{row.id_client_tipo_persona === 0 ? "Física" : "Moral"}</td>
                <td>{row.id_client_tipo_persona === 0 ? row.client_name : row.client_name_moral }</td>
                <td>{row.client_phone_number}</td>
                <td>{row.Gender}</td> <td>{row.Ocupation}</td>
              </tr>
          )
          }
            </tbody>
          </table>
        </div>        
      </div>
    </>
}
